export const locale = {
    lang: 'de',
    data: {
      'EDITOR': {
        'ACERCADE': 'Optional können Sie vor dem Erstellen der Umfrage einige Merkmale der Umfrage bearbeiten. Die vorgenommenen Änderungen können innerhalb der Umfrage angezeigt werden, sobald Sie darauf zugreifen',
        'CONCAMBIOS': 'Es wurden Änderungen an der Umfragekonfiguration festgestellt. Sie müssen zuerst die Umfrage für die vorgenommenen Änderungen erstellen, um sie später anwenden zu können. Später können Sie den Schritt ausführen',
        'CARGANDO': 'Informationen laden',
        'GUARDANDO': 'Änderungen speichern',
        'CONFIGADICIONAL': {
          'TITULO': 'Zusätzliche Konfiguration',
          'SUBTITULO': 'Diese Einstellungen gelten für die Umfrage für alle Sprachen',
          'DISPONIBLES': 'Verfügbare Steuerelemente',
          'SAVEOK': 'Die Konfiguration wurde erfolgreich aktualisiert',
          'CONTROLES': {
            'PIN': 'Aktivieren Sie den Umfrageschutz mit der Benutzer-PIN',
            'RANDOM': 'Aktivieren Sie die Frage zur zufälligen Validierung',
            'LIDERES': 'Namen von Führungskräften (CEO / Boss) in der Perspektive der Aussagen anzeigen'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Elemente dieses Blocks',
          'COLORES': {
            'ORIGINAL': 'Unverändertes Element',
            'MODIFICADO': 'Geändertes Element'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Es wurde kein Element geändert',
            'MODIFICADO': 'Ein oder mehrere Elemente wurden geändert',
            'COMPLETO': 'Alle Elemente wurden geändert'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'Es gibt kein Bild',
              'ACTUAL': 'Aktuelles Bild'
            },
            'TEXTO': {
              'INGRESAR': 'Geben Sie Ihren Text ein'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Umfrageeigenschaften bearbeiten',
            'REGRESAR': 'Geh zurück',
            'CONTINUAR': 'Fortsetzen',
            'CANCELAR': 'Stornieren',
            'GUARDAR': 'Änderungen speichern',
            'IMAGEN': 'Bild ändern',
            'EDITOR': 'Nachricht bearbeiten',
            'ELEMENTOS': 'Hilfe',
            'ACTIVAR': 'Show',
            'DESACTIVAR': 'Ausblenden',
            'ACEPTAR': 'Akzeptieren',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Anmeldung',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker-Logo',
                'ELEMENTOS': {
                  'logo': 'Sie können ein Bild hochladen, um das Logo des Brokers zu ändern'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Vorherige Anweisungen',
                'ELEMENTOS': {
                  'text': 'Sie können die anzuzeigenden Anweisungen schreiben, bevor Sie an der Umfrage teilnehmen'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Login Formular',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': 'Sie können den Hinweistext für das Feld "Passwort" ändern',
                  'buttons_login_label': 'Sie können den Text der Anmeldeschaltfläche ändern',
                  'recoveryAccessKey_text': 'Sie können den Schaltflächentext ändern, um das Kennwort wiederherzustellen',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Hintergrundbild',
                'ELEMENTOS': {
                  'backgroudImage': 'Sie können das Hintergrundbild ändern, das auf diesem Bildschirm angezeigt wird',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Generische Elemente',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker-Logo',
                'ELEMENTOS': {
                  'logo': 'Sie können ein Bild hochladen, um das Logo des Brokers zu ändern'
                }
              },
              'HEADER': {
                'TITULO': 'Header-Elemente',
                'ELEMENTOS': {
                  'buttons_logout_label': 'Sie können den Text der Anmeldeschaltfläche ändern',
                  'header_logo': 'Sie können das Image des Systemlogos ändern',
                  'isShowLastLogin_active': 'Sie können das Datum des letzten Zugriffs ein- oder ausblenden',
                  'backgroundImage': 'Sie können das Hintergrundbild ändern, das auf diesem Bildschirm angezeigt wird',
                  'header_showUserName': 'Sie können den Benutzernamen ein- oder ausblenden'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Begrüßungsbildschirm',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Bildschirminhalt',
                'ELEMENTOS': {
                  'text': 'Sie können den Inhalt des Begrüßungsbildschirms ändern',
                  'buttons_next_label': 'Sie können den Schaltflächentext ändern, um fortzufahren',
                }
              },
              'LOGOUT': {
                'TITULO': 'Meldung beim Abmelden',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'buttons_cancel_label': 'Sie können den Schaltflächentext ändern, um die Aktion abzubrechen',
                  'buttons_logout_label': 'Sie können den Text der Schaltfläche ändern, um sich abzumelden',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Anweisungsbildschirm',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Bildschirminhalt',
                'ELEMENTOS': {
                  'text': 'Sie können den Inhalt des Anweisungsbildschirms ändern',
                  'buttons_previous_label': 'Sie können den Schaltflächentext ändern, um zurückzukehren',
                  'buttons_start_label': 'Sie können den Schaltflächentext zum Starten ändern',
                  'buttons_continue_label': 'Sie können den Schaltflächentext ändern, um fortzufahren',
                }
              },
              'LOGOUT': {
                'TITULO': 'Meldung beim Abmelden',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'buttons_cancel_label': 'Sie können den Schaltflächentext ändern, um die Aktion abzubrechen',
                  'buttons_logout_label': 'Sie können den Text der Schaltfläche ändern, um sich abzumelden',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Umfrage-Akzeptanznachricht',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Aktivieren Sie die Nachricht, um die Umfrage zu akzeptieren oder abzulehnen',
                'ELEMENTOS': {
                  'active': 'Aktivieren Sie die Pre-Start-Nachricht'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Nachrichteninhalt',
                'ELEMENTOS': {
                  'header_title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Inhalt der Nachricht ändern',
                  'buttons_previous_label': 'Sie können den Schaltflächentext ändern, um zurückzukehren',
                  'buttons_acept_label': 'Sie können den Schaltflächentext ändern, um die Umfrage abzulehnen',
                  'buttons_cancel_label': 'Sie können den Schaltflächentext ändern, um die Umfrage zu akzeptieren'
                }
              },
              'LOGOUT': {
                'TITULO': 'Meldung beim Abmelden',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'buttons_cancel_label': 'Sie können den Schaltflächentext ändern, um die Aktion abzubrechen',
                  'buttons_logout_label': 'Sie können den Text der Schaltfläche ändern, um sich abzumelden',
                }
              },
              'NOACEPT': {
                'TITULO': 'Meldung beim Ablehnen der Umfrage',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'buttons_saveAndExit_label': 'Sie können den Schaltflächentext zum Bestätigen und Beenden ändern',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Umfragebildschirm',
            'PASOS': {
              'NAV': {
                'TITULO': 'Navigationstasten',
                'ELEMENTOS': {
                  'buttons_next_label': 'Sie können den Schaltflächentext ändern, um fortzufahren',
                  'buttons_previous_label': 'Sie können den Schaltflächentext ändern, um zurückzukehren',
                  'buttons_finish_label': 'Sie können den Schaltflächentext ändern, um die Umfrage zu beenden',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Anweisungsseitenwand',
                'ELEMENTOS': {
                  'button_label': 'Sie können den Schaltflächentext ändern, um das Anweisungsfeld anzuzeigen',
                  'active': 'Sie können die Schaltfläche im Bedienfeld ein- oder ausblenden',
                  'text': 'Sie können den Inhalt des Anweisungsbildschirms ändern',
                }
              },
              'SOPORTE': {
                'TITULO': 'Seitenwand der Stützspitzen',
                'ELEMENTOS': {
                  'button_label': 'Sie können den Schaltflächentext ändern, um das Support-Tipps-Bedienfeld anzuzeigen',
                  'active': 'Sie können die Schaltfläche für das Support-Tipps-Bedienfeld ein- oder ausblenden',
                  'text': 'Sie können den Inhalt des Bildschirms mit den Support-Tipps ändern',
                }
              },
              'COLUMNA1': {
                'TITULO': 'Aussagen: Perspektive 1',
                'ELEMENTOS': {
                  'title': 'Sie können den Spaltentitel von Perspektive 1 ändern',
                  'tooltip_active': 'Sie können den Tooltip für Spaltentitel ein- oder ausblenden',
                  'tooltip_text': 'Sie können den Inhalt des Tooltips für Spaltentitel ändern',
                }
              },
              'COLUMNA2': {
                'TITULO': 'Aussagen: Perspektive 2',
                'ELEMENTOS': {
                  'title': 'Sie können den Spaltentitel von Perspektive 2 ändern',
                  'tooltip_active': 'Sie können den Tooltip für Spaltentitel ein- oder ausblenden',
                  'tooltip_text': 'Sie können den Inhalt des Tooltips für Spaltentitel ändern',
                }
              },
              'FINISH_1': {
                'TITULO': 'Nachricht am Ende der Umfrage',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'textAnswered': 'Sie können den Text der angezeigten Nachricht ändern, wenn Sie alle Fragen beantworten',
                  'textNotAnswered': 'Sie können den Text der angezeigten Nachricht ändern, indem Sie nicht alle Fragen beantworten',
                  'textFooter': 'Sie können den Text der Nachricht ändern',
                  'buttons_previous_label': 'Sie können den Schaltflächentext ändern, um zurückzukehren',
                  'buttons_close_label': 'Sie können den Schaltflächentext ändern, um die Umfrage zu beenden',
                }
              },
              'FINISH_2': {
                'TITULO': 'Nachricht nach Abschluss der Umfrage',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'Sie können den Titel der Nachricht ändern',
                  'windowFinishMessage_text': 'Sie können den Text der Nachricht ändern',
                  'windowRanking_active': 'Sie können die Nachricht ein- oder ausblenden, um die Umfrage zu bewerten',
                  'windowRanking_text': 'Sie können den Text der Nachricht ändern, um die Umfrage zu bewerten',
                  'windowFinishMessage_buttons_close_label': 'Sie können den Schaltflächentext ändern, um fortzufahren',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Meldung beim Abmelden',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'textBandRequired': 'Sie können den Text der Irreversibilitätswarnmeldung ändern',
                  'buttons_previous_label': 'Sie können den Schaltflächentext ändern, um die Aktion abzubrechen',
                  'buttons_saveAndExit_label': 'Sie können den Schaltflächentext ändern, um Änderungen zu speichern und sich abzumelden',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Nachricht nach dem Abmelden',
                'ELEMENTOS': {
                  'title': 'Sie können den Titel der Nachricht ändern',
                  'text': 'Sie können den Text der Nachricht ändern',
                  'buttons_close_label': 'Sie können den Schaltflächentext ändern, um fortzufahren',
                }
              },
            }
          },
        }
      }
    }
};
